import { render, staticRenderFns } from "./answer.vue?vue&type=template&id=6d94c8d6&scoped=true&"
import script from "./answer.vue?vue&type=script&lang=js&"
export * from "./answer.vue?vue&type=script&lang=js&"
import style0 from "./answer.vue?vue&type=style&index=0&id=6d94c8d6&prod&lang=css&"
import style1 from "./answer.vue?vue&type=style&index=1&id=6d94c8d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d94c8d6",
  null
  
)

export default component.exports